<template>
    <div>
        <scenario-templates 
                v-once
                v-if="showScenarioTemplates"

                :scenarioIds="scenarioIds"
                
                @trigger-change-info="currentComponent = changeInfoComponent"
        >
        </scenario-templates>
        
        <change-info
            v-once
            v-if="showChangeInfo"
            
            @cancel-change-info="currentComponent = scenarioTemplatesComponent"
        >
        </change-info>
    </div>
</template>

<script>
    import dmVisualizerApi from "@core/Api/dm-visualizer";

    import ScenarioTemplates from "./Templates/ScenarioTemplates.vue";
    import ChangeInfo from "./ChangeInfo/Info.vue";
    
    export default {
        name: "templates",
        
        components: {
            ChangeInfo,
            ScenarioTemplates
        },

        props: {
            divisionId: {
                type: String,
                required: true,
            },
            
            scenarioIds: {
                type: Array,
                required: true
            }
        },
        
        computed: {
            showChangeInfo(){
                return this.currentComponent === this.changeInfoComponent;
            },
            
            showScenarioTemplates(){
                return this.currentComponent === this.scenarioTemplatesComponent;
            }
        },
        
        data: () => ({
            currentComponent: '',
            
            changeInfoComponent: 'changeInfo',
            scenarioTemplatesComponent: 'scenarioTemplates'
        }),


        created(){
            dmVisualizerApi.setDivisionId(this.divisionId);

            this.currentComponent = this.scenarioTemplatesComponent;
        }
    };
</script>

<style scoped>

</style>
